import { FeatureToggleClientService } from 'feature-toggle-client';
const MenuRedesignEnabled = 'growth-menu-redesign';
const StilingueMenuEnabled = 'growth-menu-stilingue';
const messageTemplatePaymentFeatureToggle = 'message-template-payment-card-feature-toggle';
export class GrowthFeatures {
    static isMenuRedesignEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(MenuRedesignEnabled);
    }
    static IsStilingueMenuEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(StilingueMenuEnabled);
    }
    static isPaymentsReportFeatureEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(messageTemplatePaymentFeatureToggle);
    }
}
